import React from 'react';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
import { S } from './style';
import { ChevronRight } from '../../Icon';
export default function InputPopup({ onInputClick, title, displayValue, placeHolder, isError, errMessage, isFull, elementRef, }) {
    return (<div ref={elementRef}>
      <S.FieldBox onClick={onInputClick} isError={isError} isFull={isFull}>
        <S.FieldTitle isError={isError}>{title && `${title}：`}</S.FieldTitle>
        {displayValue ? (<S.Text>{displayValue}</S.Text>) : (<S.Text isPlaceholder>{placeHolder}</S.Text>)}
        <S.Button>
          <ChevronRight color={isError ? SEMANTIC_COLORS.ERROR_ICON : SEMANTIC_COLORS.SECONDARY_ICON} size='30px'/>
        </S.Button>
      </S.FieldBox>
      {isError ? <S.FeedbackErrorText>{errMessage}</S.FeedbackErrorText> : null}
    </div>);
}
